import axios from "axios";

export async function fetchRosterFile(handleId) {
  const { data } = await axios.post(
    "/api/user/roster-file",
    { handleId },
    { withCredentials: true }
  );
  return data;
}

export async function fetchRosterFileRibbons(handleId, opts = {}) {
  const { scope, includeAll } = opts || {};
  const { data } = await axios.post(
    "/api/user/roster-file-ribbons",
    { handleId, scope, includeAll },
    { withCredentials: true }
  );
  return data;
}

export async function fetchRosterFileSectionOptions(handleId) {
  const { data } = await axios.post(
    "/api/user/roster-file-section-options",
    { handleId },
    { withCredentials: true }
  );
  return data;
}

/** @deprecated Assignment is required; use saveRosterFileSectionWithAssignment. */
export async function saveRosterFileSection(handleId, orgDivisionId) {
  const { data } = await axios.post(
    "/api/user/roster-file-section",
    { handleId, orgDivisionId },
    { withCredentials: true }
  );
  return data;
}

export async function saveRosterFileSectionWithAssignment(handleId, orgDivisionId, assignmentId) {
  const { data } = await axios.post(
    "/api/user/roster-file-section",
    { handleId, orgDivisionId, assignmentId },
    { withCredentials: true }
  );
  return data;
}

export async function fetchRosterFileHistoryEvents(handleId, opts = {}) {
  const { scope } = opts || {};
  const { data } = await axios.post(
    "/api/user/roster-file-history-events",
    { handleId, scope },
    { withCredentials: true }
  );
  return data;
}

